import {Button, Spacer, Layout} from '@di-nxt/components';
import React from 'react';
import {t} from '../../localization';

type Props = {
  onSave: () => void;
  onCancel: () => void;
};

export const DataRowSaveCancelButtons: React.FC<Props> = ({
  onSave,
  onCancel,
}) => {
  return (
    <Layout vertical>
      <Spacer height="16" />
      <Layout horizontal>
        <Button
          kind="Secondary"
          size="Default"
          title={t('general.cancel')}
          onPress={onCancel}
        />
        <Spacer width="8" />
        <Button
          kind="Positive"
          size="Default"
          title={t('general.save')}
          onPress={onSave}
        />
      </Layout>
    </Layout>
  );
};
